import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useSelector } from "react-redux"

import Filter from "./mobile/filter"
import Backdrop from "../../../Backdrop"
import { Link } from "react-router-dom"
import InfoIcon from "../../../InfoIcon"
import { faCircleArrowDown } from "@fortawesome/free-solid-svg-icons"

export default function MobileComponent() {

    const [mobileItems, setMobileItems] = useState()

    let filteredFavorites = useSelector((state) => state.favorite.filteredFavorites)
    let stateFavorites = useSelector(state => state.favorite.favorites)


    useEffect(() => {

        let items = []
        let favorites = filteredFavorites ?? stateFavorites

        if (favorites && Object.keys(favorites).length > 0) {

            favorites.forEach((favorite) => {

                items.push(<MobileItem key={favorite.id} favorite={favorite} />)

            })
        }
        setMobileItems(items)



    }, [filteredFavorites, stateFavorites])


    if (!mobileItems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            {mobileItems}
        </Filter>
        <Backdrop />
    </Fragment>
}


function MobileItem(props) {
    const { favorite } = props

    const [showContent, setShowContent] = useState(false)


    return <Fragment>

            <button type="button" className="mobile-overflow-card card shadow bg-white rounded p-3 mb-2 w-100 text-start border-0" aria-expanded={showContent} onClick={() => {
                setShowContent(!showContent)
            }}  >
                <div className="responsive-card-summary" >
                    <span>{favorite.ptitle}</span>
                    <span className="text-muted small">{favorite.created_on}</span>
                </div>
                <InfoIcon icon={faCircleArrowDown} size='xl' />

            </button>
            {showContent &&
                <div className="table-responsive mb-3"><table className="table table-striped table-bordered mb-0" >
                    <tbody>
                        <tr>
                            <th>ProductTitle</th>
                            <td className="text-break">
                            <Link to={`/products/${favorite.product_id}`} state={{ product: null }}>{favorite.ptitle}</Link>
                            </td>
                        </tr>
                        <tr>
                            <th>CreatedOn</th>
                            <td>{favorite.created_on}</td>
                        </tr>
                    </tbody>
                </table></div>
            }


    </Fragment>

}
